export const isStagingEnv = process.env.REACT_APP_NODE_ENV === "staging";
export const isDevelopmentEnv = process.env.REACT_APP_NODE_ENV === "dev";
export const isProductionEnv = process.env.REACT_APP_NODE_ENV === "production";